import androidWebViewApi from 'utilities/androidWebViewApi'

interface IAppState {
    isOffline: boolean
    isFullscreen: boolean
}

const initialState: IAppState = {
    isOffline: false,
    // The Android WebView app starts in full screen.
    isFullscreen: androidWebViewApi.isRunInAndroidWebView(),
}

export const CHANGE_OFFLINE_STATUS = 'CHANGE_OFFLINE_STATUS'
export const TOGGLE_OFFLINE_STATUS = 'TOGGLE_OFFLINE_STATUS'
export const TOGGLE_FULLSCREEN_STATE = 'TOGGLE_FULLSCREEN_STATE'

function appStateReducer(
    state: IAppState = initialState,
    action: { type: string; payload: boolean },
): IAppState {
    switch (action.type) {
        case CHANGE_OFFLINE_STATUS:
            return {
                ...state,
                isOffline: action.payload,
            }
        case TOGGLE_OFFLINE_STATUS:
            return {
                ...state,
                isOffline: !state.isOffline,
            }
        case TOGGLE_FULLSCREEN_STATE:
            return {
                ...state,
                isFullscreen: !state.isFullscreen,
            }
        default:
            return state
    }
}

export default appStateReducer
